import { carouselItems } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-600">深度专题报道，全方位吃瓜不迷路</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}